
import React, { Component,Suspense } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';

import { MDBDataTable } from "mdbreact"

import { format } from 'date-fns';
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardHeader,
  CardTitle,
  FormGroup,
  Label,
  Button,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Breadcrumb,
  BreadcrumbItem,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Dropdown,
  Spinner
} from "reactstrap"

import Select from "react-select"
import {component} from "react-select"
import axios from 'axios'
import  { Redirect,useHistory } from 'react-router-dom'
 import $ from "jquery"

import Flatpickr from "react-flatpickr"
import ReactSelect from 'react-select'
import makeAnimated from 'react-select/animated';
import url from "../../common/api"
//import BootstrapSelect from "bootstrap-select"
import "./ListeRessource.css"
import DetailRessource from './../Ressources/DetailRessource';
import ReadMoreText from "read-more-less-react";
import "read-more-less-react/dist/index.css";
import {getProfileRessource,getRessourceByProfile,getRessourceByUser} from "../../services/ressourceService.js"

class ListeRessource extends Component {

    constructor(props) {
        super(props)
        this.state = {
    
          selectedGroupLocalisation: null,
          selectedGroupTypeIrrigation: null,
          selectedGroupLangue: null,
          selectedGroupThematique: null,
    
          tooltipContent: ["Rate 1", "Rate 2", "Rate 3", "Rate 4", "Rate 5"],
          tooltipContentMore: ["1", "2", "3", "4", "5", "6", "7", "8"],
          tooltipContentHalf: ["6", "7", "8", "9", "10"],
          tooltipContentMiddle: [ "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12",],
          tooltipContentStep: ["2", "4", "6", "8", "10"],
          default: "",
          half: "",
          customize: "",
          ok:"",
          chargement:false,
          ressourceData:[],
          entriesLabelList: ["5", "10", "20", "50", "100"],
          droit:JSON.parse(sessionStorage.getItem("profileAuthAshia"))?.droit_ressource?.creer?true:false,
          modal: false,
          subscribemodal: false,
          ressource:[],
          dropdownOpen: false,
          show_detail:false,
          title:"Tous les ressources"
        }
        this.handleDetail.bind(this)
        this.togglemodal.bind(this)
        this.togglesubscribemodal.bind(this)
        this.handleRechercheSimple.bind(this)
        this.toggle = this.toggle.bind(this);
        this.handleShowRessource=this.handleShowRessource.bind(this)
      }

       history =()=> useHistory();
    
      componentDidMount() {
        sessionStorage.setItem("sis-session",900000)
        $('#block_detail_liste').hide()
        $('#block_page').show()
  
        this.handleChargerData()
    
        $(".leFiltre").css("display","none")
    
      }

      handleShowRessource=(data)=>{
        data.map((element,idx) =>{

          const description=element.description.substr(0,300)
          var tab= {
            id: element.id,
            nom: element.nom,
            description: element.description.length>=300?description+" ...":description,
         
            statut: element.statut,
            nombredevue :
              <span 
                style={{backgroundColor:"#6A7172"}} 
                data-toggle="tooltip" 
                data-placement="top" 
                data-html="true"
                title="Nombre de consultation de la ressource"
                class="badge rounded-pill "
              >
                {element.nombre_vue}
              </span>,
            nombredetelechargement :
              <span style={{backgroundColor:"#6A7172"}} 
                data-toggle="tooltip" 
                data-placement="top" 
                data-html="true"
                title="Nombre de téléchargements de la ressource"
                class="badge rounded-pill "
              >
                {element.nombre_telecharge}
              </span>,
              action: <span style={{backgroundColor:"#5FC4E1"}} className="badge rounded-pill"> <a onClick={this.handleDetail.bind(this.bind,element.id)} >Consulter</a></span>,
              // action: <a > <i onClick={this.handleDetail.bind(this.bind,element.id)} className="bx bxs-pencil bx-sm text-info "/> </a>,
            
          }
         
          this.setState({ressource:[...this.state.ressource,tab]})
        })
        $(".rm-more-button").css("color","green")
        $(".rm-more-button").css("border","groove 0.1em #6A7172")
        $(".rm-more-button").css("border-radius","2em")
      }
      
      handleChargerData=()=>{
        const profile_id=JSON.parse(sessionStorage.getItem("authAshia"))?.profile?.id?JSON.parse(sessionStorage.getItem("authAshia"))?.profile?.id:JSON.parse(sessionStorage.getItem("authPublic"))?.id


        this.setState({title:"",chargement:false,ressource:[]})
        getRessourceByProfile({profile_id}).then(data=>{
        
            
            this.setState({ressourceData:data,title:"Toutes les ressources",chargement:true})
            //data.ressources.filter((dt)=>(new Date(dt.date_debut_publication))<=(new Date()) && (new Date(dt.date_fin_publication))>=(new Date())).map((element,idx) =>{
            this.handleShowRessource(data)
            $('#clickMesRessources').show()
        })
     
           
      }
    
      togglemodal = () => {
        this.setState(prevState => ({
          modal: !prevState.modal,
        }))
      }
    
      togglesubscribemodal = () => {
        this.setState(prevState => ({
          subscribemodal: !prevState.subscribemodal,
        }))
      }
      handleDuBouttonRecherche = () => {
        $(".leFiltre").css("display","block")
        $(".laRecherche").css("display","none")
      }
    
      handleDuBouttonFiltre = () => {
        $(".laRecherche").css("display","block")
        $(".leFiltre").css("display","none")
      }
    
      handleSelectGroupLocalisation = selectedGroupLocalisation => {
        this.setState({ selectedGroupLocalisation })
      }
      handleSelectGroupTypeIrrigation = selectedGroupTypeIrrigation => {
        this.setState({ selectedGroupTypeIrrigation })
      }
      handleSelectGroupLangue = selectedGroupLangue => {
        this.setState({ selectedGroupLangue })
      }
      handleSelectGroupThematique = selectedGroupThematique => {
        this.setState({ selectedGroupThematique })
      }
      handleAddRessource=()=>{
        this.setState({ok: <Redirect to='/ajout-ressource' />});
      }
    
      handleDetail=(id)=>{
        sessionStorage.setItem('idressource',id);
        this.setState({ok: <Redirect to='/detail-ressource'  />});
        // this.setState({block_detail:"",show_detail:true})
    
        // setTimeout(()=>{ 
        //   this.handleRefresh()
        // }, 1);
        
      }

      handleRefresh=()=>{
        this.setState({block_detail:<DetailRessource type={true}/>})
        $('#block_page_liste').hide()
        $('#block_detail').show()
        this.setState({show_detail:false})
      }
    
      handleRechercheSimple=(e)=>{
        console.log("donee",e.target.value)
        this.setState({ressource:[]})
        var data=[]

              
        setTimeout(()=>
            this.handleShowRessource(this.state.ressourceData.filter((data) =>  JSON.stringify(data).toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1))
        , 100)
     
      
        if(e.target.value==""){
          this.setState({ressource:[]})

          this.handleChargerData()
        }
      }

    getRessourceMyRessource=()=>{
       this.setState({chargement:false,title:"",ressource:[]})
        getRessourceByUser({utilisateur_id:JSON.parse(sessionStorage.getItem("authAshia")).id}).then(data=>{
          this.setState({chargement:true,ressourceData:data,title:"Mes ressources"})
          this.handleShowRessource(data)
         
        })
    }



    
      loading = () => <Spinner animation="grow" />
      goBack=()=>useHistory().goBack();

      toggle() {
        this.setState(prevState => ({
          dropdownOpen: !prevState.dropdownOpen
        }));
      }
    

  render() {

    const data = {
      columns: [
        {
          label: "Titre",
          field: "nom",
          sort: "asc",
          width: 150,
        },
        {
          label: "Résumé",
          field: "description",
          sort: "asc",
          width: 10,
          height: 10,
        },
        {
          label: <i style={{color:"#6A7172"}} className="fa fa-eye "></i>,
          field: "nombredevue",
          sort: "asc",
          width: 100,
        },
        {
          label: 
          <div
            data-toggle="tooltip" 
            data-placement="top" 
            data-html="true"
            title="Organisme de tutelle ou personne qui a écrit le document"
          >
            <i style={{color:"#6A7172"}} className="fa fa-download "></i>
          </div>,

          field: "nombredetelechargement",
          sort: "asc",
          width: 100,
        },
        {
          label: "Fiche",
          field: "action",
          sort: "asc",
          width: 100,
        },
      ],
      // rows:this.state.ressource_.sortBy(this.state.ressource, 'created_at').reverse()
      rows:_.sortBy(this.state.ressource, 'created_at').reverse()
    }


    return (
      <React.Fragment >
        <div id="block_page_liste" className="page-content"> {this.state.ok}
          
          
          <MetaTags>
            <title>Ressources | SIS</title>
          </MetaTags>

          <Container fluid={true}>
            {/* <h1 onClick={this.goBack}>Go</h1> */}
            <Row>
              <Col md="8">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  {/* <h4 className="mb-0 font-size-18">Ressources</h4> */}
                </div>
              </Col>
            </Row>

            <Card style={{borderRadius:"65px",borderColor:"#032e87",borderWidth:"5px"}}>
              <CardBody>
                {/* <label><strong>RECHERCHE</strong></label> */}
                <Row>
                  <Col lg="6" md="6" sm="12" className="mb-2">
                    <div className="form-outline" class="form">
                      <input
                        onChange={this.handleRechercheSimple}
                        type="search"
                        className="form-control "
                        placeholder="Saisissez votre recherche..."
                        style={{borderRadius:"40px"}}
                      />
                    </div>
                  </Col>
                  {
                    this.state.droit?
                    <Col lg="2" md="2" sm="12" className="pull-right">
                        <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                          <DropdownToggle style={{borderRadius:"40px"}} color="info" caret>
                            {this.state.title}
                            {
                              !this.state.chargement?<>Chargement... <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/></>:null
                            }
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem onClick={this.handleChargerData}>Toutes les resources</DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem onClick={this.getRessourceMyRessource}>Mes resources</DropdownItem>
                          </DropdownMenu>
                      </Dropdown>
                    </Col>:null
                  }
                  {this.state.droit?
                    <Col lg="4" md="4" sm="12" className="pull-right">
                      <Button
                        color="success"
                        className="font-16 btn-block btn   float-right"
                        onClick={this.handleAddRessource}
                        //href="/ajout-evenement"
                        // style={{backgroundColor:"#6A7172"}}
                        style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"40px"}}
                      >
                        <i className="mdi mdi-plus-circle-outline me-1" />
                        Ajouter une ressource
                      </Button>
                    </Col>:null
                  }
                </Row>
              </CardBody>
            </Card>

            <Row>
              <Col className="col-12 mt-4">
              {
                (this.state.chargement)?
       
                <Card style={{borderRadius:"25px",borderColor:"#6A7172",borderWidth:"5px"}}>
                  <CardBody>
                    <CardTitle className="h4 mb-5">
                      <Row>
                        <Col  className="mr-5">
                          LISTE DES RESSOURCES 
                        </Col>
                        


                      </Row>
                    </CardTitle>
                    


                    <p className="card-title-desc">
                      {/* Description du tableau. */}
                    </p>
                    {/* <Suspense fallback={this.loading()}> */}
                      <MDBDataTable responsive sortable={false} style={{textAlign:"justify"}} striped bordered entries="5" entrieslabel="5" entriesOptions={this.state.entriesLabelList} maxHeight="200px" searching={false} data={data} />
                    {/* </Suspense> */}
                  </CardBody>
                </Card>
                :(
                  <div style={{marginTop:"150px",textAlign:"center"}}>
                    <Spinner type="grow" color="secondary" />
                 </div>
                )
              }
              </Col>
            </Row>
          </Container>
        </div>
       
      </React.Fragment>
    )
  }
}
export default ListeRessource